import PropTypes from 'prop-types';
import React from 'react';

import StateLinksCard from './StateLinksCard';

// {
//   title: '',
//   href: '',
//   external: true,
// },

function RelatedInfoLinks({ relInfoLinks }) {
  const links = relInfoLinks.map(ril => ({
    title: ril.LinkLabel,
    href: ril.Link,
    external: true,
  }));
  return <StateLinksCard category="Related Information & Links" iconId={37} links={links} />;
}

RelatedInfoLinks.propTypes = {
  // stateCode: PropTypes.string.isRequired,
  relInfoLinks: PropTypes.array.isRequired,
};

export default RelatedInfoLinks;
